import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import API from "../../api/api";
import Toast from "../../components/Toast";
import "./Gallery.css";

const IMG_BASE = "https://cmsapi.mks.org.au/uploads/";

function GalleryImages() {
    const { id } = useParams();
    const [list, setList] = useState([]);
    const [loading, setLoading] = useState(false);
    const [uploading, setUploading] = useState(false);
    const [toast, setToast] = useState(null);

    const fetchImages = () => {
        setLoading(true);
        console.log(`Fetching gallery images for event ID ${id} from /gallery/${id}...`);
        API.get(`/gallery/${id}`)
            .then(res => {
                console.log("Gallery images received:", res.data);
                setList(res.data);
            })
            .catch(err => {
                console.error("Error fetching gallery images:", err);
                console.error("Error details:", err.response?.data || err.message);
                setList([]);
            })
            .finally(() => setLoading(false));
    };

    useEffect(() => {
        fetchImages();
    }, [id]);

    const handleUpload = async (e) => {
        const files = Array.from(e.target.files);
        if (files.length === 0) return;

        setUploading(true);
        try {
            const form = new FormData();
            files.forEach(f => {
                form.append("images", f);
            });

            await API.post(`/gallery/${id}/images`, form, {
                headers: { "Content-Type": "multipart/form-data" }
            });

            showToast("Images uploaded successfully");
            fetchImages();
        } catch (err) {
            showToast("Error uploading images", "error");
        } finally {
            setUploading(false);
            e.target.value = ""; // reset input
        }
    };

    const deleteImg = async (imgId) => {
        if (window.confirm("Delete this image?")) {
            try {
                await API.delete(`/gallery/image/${imgId}`);
                showToast("Image deleted");
                setList(list.filter(x => x.ImageId !== imgId));
            } catch (err) {
                showToast("Error deleting image", "error");
            }
        }
    };

    const showToast = (message, type = "success") => {
        setToast({ message, type });
    };

    return (
        <div className="admin-card animate-fade-in">
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "30px", flexWrap: "wrap", gap: "20px" }}>
                <div>
                    <Link to="/gallery" className="back-link">
                        &larr; Back to Gallery Events
                    </Link>
                    <h2 style={{ margin: 0, color: "var(--text-dark)", fontSize: "1.75rem", fontWeight: "800" }}>Gallery Photos</h2>
                </div>

                <div>
                    <label className="btn btn-primary" style={{ cursor: "pointer", height: "45px" }}>
                        {uploading ? "Uploading..." : "+ Upload Photos"}
                        <input type="file" multiple hidden disabled={uploading} onChange={handleUpload} />
                    </label>
                </div>
            </div>

            {loading ? (
                <div style={{ textAlign: "center", padding: "100px" }}>
                    <div className="spinner"></div>
                    <p style={{ marginTop: "15px", color: "var(--text-muted)" }}>Fetching photos...</p>
                </div>
            ) : (
                <div className="photo-grid">
                    {list.map(img => (
                        <div key={img.ImageId} className="photo-item">
                            <img
                                src={img.ImageFile ? (img.ImageFile.startsWith('http') ? img.ImageFile : IMG_BASE + img.ImageFile) : "https://via.placeholder.com/300x300?text=No+Image"}
                                alt="Gallery item"
                            />
                            <button
                                onClick={() => deleteImg(img.ImageId)}
                                className="photo-delete-btn"
                                title="Delete Photo"
                            >
                                🗑️
                            </button>
                        </div>
                    ))}
                </div>
            )}

            {list.length === 0 && !loading && (
                <div style={{ textAlign: "center", padding: "40px", color: "var(--text-muted)" }}>
                    No photos found in this gallery yet.
                </div>
            )}

            {toast && <Toast message={toast.message} type={toast.type} onClose={() => setToast(null)} />}
        </div>
    );
}

export default GalleryImages;